// extracted by mini-css-extract-plugin
export default {"description":"ProfilePetData_description__5qBDZ","error":"ProfilePetData_error__kvy5K"};